const mediaQueries = {
  mobile: window.matchMedia('screen and (max-width: 767px)'),
  mobileSmall: window.matchMedia('screen and (max-width: 374px)'),
  mobileLarge: window.matchMedia('screen and (min-width: 375px) and (max-width: 767px)'),
  tablet: window.matchMedia('screen and (min-width: 768px) and (max-width: 1023px)'),
  desktop: window.matchMedia('screen and (min-width: 1024px)')
}

export default {
  data () {
    return {
      mobile: true,
      mobileSmall: true,
      mobileLarge: false,
      tablet: false,
      desktop: false
    }
  },
  methods: {
    updateMediaQuery () {
      this.mobile = mediaQueries.mobile.matches
      this.mobileSmall = mediaQueries.mobileSmall.matches
      this.mobileLarge = mediaQueries.mobileLarge.matches
      this.tablet = mediaQueries.tablet.matches
      this.desktop = mediaQueries.desktop.matches
    }
  },
  created () {
    this.updateMediaQuery()
    Object.keys(mediaQueries).forEach((device) => {
      mediaQueries[device].addListener(this.updateMediaQuery)
    })
  },
  beforeDestroy () {
    Object.keys(mediaQueries).forEach((device) => {
      mediaQueries[device].removeListener(this.updateMediaQuery)
    })
  }
}
